import { render, staticRenderFns } from "./ConfigForm.vue?vue&type=template&id=476f65aa&scoped=true&"
import script from "./ConfigForm.vue?vue&type=script&lang=js&"
export * from "./ConfigForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "476f65aa",
  null
  
)

export default component.exports